// This is the profile section
import React from "react";
import ProfileComponent from "../../../components/SideTab/Profile";

const ProfileDetail = () => {
  return <ProfileComponent />;
};

export default ProfileDetail;
